var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 63,
    viewBox: "0 0 44 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1825 25.1707H16.219C15.4416 24.1605 14.9935 22.9396 14.9343 21.6707V19.1253C15.1868 17.8648 15.1868 16.5675 14.9343 15.3071L14.292 13.398V11.4889C14.292 11.4889 14.555 10.5395 15.4161 10.5H16.3796C16.3796 10.5 17.5602 10.5738 17.5037 11.4889V13.398C17.5037 13.398 16.9179 16.5738 17.8248 19.4435V21.6707C17.8248 21.6707 18.0542 24.5799 17.1825 25.1707Z",
    fill: "#2F3567"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1827 25.166H16.2192V27.3933H17.1827V25.166Z",
    fill: "#FF6F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8612 27.0752H16.54V29.3025H16.8612V27.0752Z",
    fill: "#FF6F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0658 24.2164H28.1023C27.3249 23.2063 26.8768 21.9854 26.8176 20.7164V18.171C26.8176 18.171 27.2872 17.0287 26.8176 14.3528L26.1753 12.4437V10.5346C26.1753 10.5346 26.2777 9.61953 27.1388 9.58008H28.1023C28.1023 9.58008 29.4435 9.61953 29.387 10.5346V12.4437C29.387 12.4437 28.8012 15.6195 29.7081 18.4892V20.7164C29.7081 20.7164 29.9375 23.6256 29.0658 24.2164Z",
    fill: "#2F3567"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.066 24.2119H28.1025V26.4392H29.066V24.2119Z",
    fill: "#FF6F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7445 26.1211H28.4233V28.3484H28.7445V26.1211Z",
    fill: "#FF6F3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6424 22.3072H21.6789C21.2531 21.385 21.011 20.39 20.9659 19.3768V17.3913C20.9659 17.3913 21.332 16.5004 20.9659 14.4132L20.4648 12.9241V11.435C20.4834 11.2437 20.5685 11.0648 20.7056 10.929C20.8427 10.7931 21.0233 10.7088 21.2164 10.6904H21.9679C21.9679 10.6904 23.014 10.7222 22.97 11.435V12.9241C22.97 12.9241 22.5139 15.4002 23.2205 17.6395V19.3774C23.2205 19.3774 23.3223 21.8462 22.6424 22.3072Z",
    fill: "#2F3567"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6787 22.3076H22.6422V23.8994H21.6787V22.3076Z",
    fill: "#FF6F3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.472 23.5957H22.2212V25.326H22.472V23.5957Z",
    fill: "#FF6F3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4526 17.2161L39.6643 15.9433V11.807C39.6643 11.807 40.4165 0.373752 26.1752 0.988797H14.292L9.79567 1.30698C9.79567 1.30698 0.620866 1.26466 0.802968 8.62516L3.05114 53.807C3.05114 53.807 3.57561 62.5462 11.4015 62.0797C11.4015 62.0797 25.6077 62.4825 35.8103 58.2615C35.8103 58.2615 41.2165 55.9916 41.2701 49.9888L40.949 36.9433C40.949 36.9433 41.088 31.6189 35.8103 33.7615L29.3869 35.9888L28.7446 39.4888C28.7446 39.4888 31.7099 37.7916 33.2409 37.5797C33.2409 37.5797 38.069 36.6462 37.7373 40.4433C37.7373 40.4433 38.4063 45.322 35.1679 47.1252C35.1679 47.1252 31.5012 50.1479 22.9636 50.9433C22.9636 50.9433 23.0975 49.2462 22 48.3979C22 48.3979 21.9198 45.5342 25.2117 44.8979V41.3979C25.2117 41.3979 20.3676 40.9206 22.3212 35.9888L19.7519 33.7615L18.4672 34.7161C18.4672 34.7161 16.4063 35.4584 15.5767 34.0797L14.6132 31.5342H11.0803C11.0803 31.5342 10.8931 34.6098 8.83216 34.7161C8.25881 34.8087 7.67171 34.7708 7.11529 34.6055C6.55887 34.4401 6.04771 34.1515 5.62049 33.7615L4.65698 10.5343C4.65698 10.5343 4.41611 5.5493 11.0803 5.44334H27.7811C27.7811 5.44334 35.4088 4.80698 36.1314 11.807L36.4526 17.2161Z",
    fill: "#FF6F3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3287 48.3931C15.9894 48.3931 18.1463 46.2563 18.1463 43.6204C18.1463 40.9845 15.9894 38.8477 13.3287 38.8477C10.6681 38.8477 8.51123 40.9845 8.51123 43.6204C8.51123 46.2563 10.6681 48.3931 13.3287 48.3931Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9272 57.8589C25.1244 57.8589 26.095 56.8974 26.095 55.7112C26.095 54.525 25.1244 53.5635 23.9272 53.5635C22.7299 53.5635 21.7593 54.525 21.7593 55.7112C21.7593 56.8974 22.7299 57.8589 23.9272 57.8589Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0511 2.89355H16.0584C15.7923 2.89355 15.5767 3.10736 15.5767 3.3711C15.5767 3.63483 15.7923 3.84864 16.0584 3.84864H25.0511C25.3172 3.84864 25.5329 3.63483 25.5329 3.3711C25.5329 3.10736 25.3172 2.89355 25.0511 2.89355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.14b24f417b79e76baa115b259e6e987e.svg";
export { ForwardRef as ReactComponent };